import React from 'react';
import PropTypes from 'prop-types';

function IconGenres({ color = '#8C8C8C', size = 24, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10121_41216)">
        <path d="M5.25 9.75H2.25C1.83579 9.75 1.5 10.0858 1.5 10.5V13.5C1.5 13.9142 1.83579 14.25 2.25 14.25H5.25C5.66421 14.25 6 13.9142 6 13.5V10.5C6 10.0858 5.66421 9.75 5.25 9.75Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M19.5 3.75H15C14.5858 3.75 14.25 4.08579 14.25 4.5V9C14.25 9.41421 14.5858 9.75 15 9.75H19.5C19.9142 9.75 20.25 9.41421 20.25 9V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M19.5 14.25H15C14.5858 14.25 14.25 14.5858 14.25 15V19.5C14.25 19.9142 14.5858 20.25 15 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V15C20.25 14.5858 19.9142 14.25 19.5 14.25Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6 12H10.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.25 17.25H12C11.6022 17.25 11.2206 17.092 10.9393 16.8107C10.658 16.5294 10.5 16.1478 10.5 15.75V8.25C10.5 7.85218 10.658 7.47064 10.9393 7.18934C11.2206 6.90804 11.6022 6.75 12 6.75H14.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_10121_41216">
          <rect width={size} height={size} fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

IconGenres.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconGenres;
